export default {
    mfaLogin: {
        heading: "双重认证登入",
        error: "发生问题，请重新整理后再试一次。如果问题仍然持续，请电邮至 <a href=\"mailto:support@edcity.hk\" target=\"_top\">support@edcity.hk</a>。 ",
        error04: "由于你未能于限时内完成双重认证，请重新登入。",
        error07: "此电邮地址不能用于双重认证登入。",
        mfaEmailTitle: "学校管理员启用双重认证登入",
        mfaEmailSubtitle: "请提供电邮地址以启用双重认证。确认电邮将会发送到您输入的电邮地址。<br>1. 可沿用学校管理员的登入电邮作双重认证登入。<br>2. 请勿使用其他教城帐户的登入电邮作学校管理员的双重认证登入 。",
        mfaEmailRemind: "确认电邮已经发送到您早前输入的电邮地址，请点按此处继续验证流程。 ",
        mfaEmailRemindSubtitle: "如您没有收到确认电邮或需作出其他更改，请重新填写。",
        loginEmail: "登入电邮",
        loginEmailError: "登入电邮格式不正确",
        loginEmailHint: "以此电邮将用于验证教城帐户登入电邮作为双重认证登入",
        loginEmailUnaccepted: "此电邮不能作为登记用户，请使用其他电邮。",
        loginEmailInUse: "电邮地址已用于其他教城帐户。请使用其他电邮地址。",
        loginEmailPending: "此电邮地址已被登记，并正等待启用。",
        alreadyVerifiedAsTeacher: "电邮地址已用于其他教城个人教师帐户。请使用其他电邮地址。",
        completed: "验证帐户的电邮已发送至 <span class='orangeText'>{loginEmail}</span> 。请于 {expireAt} 或之前点按电邮中的连结以完成双重认证；并请于完成验证后按「已完成验证」以继续登入。",
        hold: "24小时内已尝试提交错误双重认证登入5次，请在{displayDatetime}之后再尝试。",
        wait: "学校管理员的双重认证尚未完成，请点按确认电邮中的连结完成认证。 ",
    },
    mfaLoginEmailVerification: {
        heading: "已成功验证",
        mainMessage: "确认更新帐户登入电邮并作为双重认证登入之用",
        success: "您已经成功更新登入电邮及设定学校管理员双重认证至{email}。 ",
    },
    otpLogin: {
        heading: "一次性密码登入",
        error: "登入电邮/登入名称无效",
        error01: "发生问题，请重新整理后再试一次。如果问题仍然持续，请电邮至 <a href=\"mailto:support@edcity.hk\" target=\"_top\">support@edcity.hk</a>。",
        error04: "由于你未能于限时内完成一次性密码登入，请重新登入。",
        errorSchoolAdmin: "(学校管理员请使用密码登入)",
        loginEmail: "登入电邮/登入名称",
        loginEmailError: "登入电邮/登入名称格式错误",
        otpEmailTitle: "使用一次性密码登入",
        otpEmailSubtitle: "一次性密码将发送至您的登入电子邮件。",
        hold:"24小时内已尝试提交错误一次性密码登入5次，请在{displayDatetime}之后再尝试，或以密码重新登入。",
    },
    button: {
        back: "重新登入",
        submit: "提交",
        verified: "已完成验证",
        login: "登入",
        send: "发送",
        resend: "重新发送",
        close: "返回",
        more: " ...更多",
    },
    text: {
        loginTitle: "输入一次性密码",
        loginSubtitle: "请输入发送到您登入电邮 <span class='orangeText'>{loginEmail}</span> 的一次性密码。如果您无法收到一次性密码，请电邮至 <a href=\"mailto:support@edcity.hk\" target=\"_top\">support@edcity.hk</a>。",
        otp: "一次性密码",
        verifySuccess: "验证成功",
        countdown: "一次性密码有效时间：",
        codeExpired: "一次性密码已逾时，请按重新发送",
        codeInvalid: "一次性密码错误。",
        codeNotFound:"找不到对应记录，请返回重新发送。",
    }
}